import { render } from "./Slfw2023.vue?vue&type=template&id=0164d50a&scoped=true"
import script from "./Slfw2023.vue?vue&type=script&lang=js"
export * from "./Slfw2023.vue?vue&type=script&lang=js"

import "./Slfw2023.vue?vue&type=style&index=0&id=0164d50a&scoped=true&lang=css"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0164d50a"]])

export default __exports__